import * as React from "react"

const TokoramePointSvg = (props) => (
  <svg
    width={17}
    height={19}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <mask
      id="a"
      style={{
        maskType: "alpha",
      }}
      maskUnits="userSpaceOnUse"
      x={0}
      y={0}
      width={16}
      height={19}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.945 17.713c4.371 0 7.914-3.853 7.914-8.606C15.86 4.353 12.316.5 7.945.5 3.575.5.031 4.353.031 9.107c0 2.126.71 4.073 1.885 5.574l-.827 2.645c-.155.497.308.955.748.741l2.576-1.255h.002a7.368 7.368 0 0 0 3.53.901Z"
        fill="#fff"
      />
    </mask>
    <g mask="url(#a)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.945 17.713c4.371 0 7.914-3.853 7.914-8.606C15.86 4.353 12.316.5 7.945.5 3.575.5.031 4.353.031 9.107c0 2.126.71 4.073 1.885 5.574l-.827 2.645c-.155.497.308.955.748.741l2.576-1.255h.002a7.368 7.368 0 0 0 3.53.901Z"
        fill="#F2C94C"
      />
      <path
        d="m1.916 14.681.522.194.1-.323-.202-.26-.42.39Zm-.827 2.645-.522-.193.522.193Zm.748.741.226.548-.226-.548Zm2.575-1.255.226.548-.226-.548Zm.003 0 .246-.538-.235-.127-.239.118.228.546Zm10.893-7.705c0 4.421-3.297 8.006-7.363 8.006v1.2c4.676 0 8.466-4.122 8.466-9.206h-1.103ZM7.945 1.1c4.066 0 7.363 3.585 7.363 8.007h1.103c0-5.085-3.79-9.207-8.466-9.207v1.2ZM.583 9.107C.583 4.685 3.879 1.1 7.945 1.1V-.1C3.27-.1-.52 4.022-.52 9.107H.583Zm1.753 5.186C1.242 12.895.583 11.085.583 9.107H-.521c0 2.274.76 4.357 2.017 5.963l.84-.777Zm-.724 3.226.826-2.644-1.045-.387-.826 2.645 1.045.386Zm0 0-1.045-.386c-.31.993.616 1.91 1.496 1.482l-.451-1.096Zm2.575-1.254-2.575 1.254.45 1.096 2.576-1.255-.451-1.095Zm0 0 .451 1.095.004-.002-.455-1.093Zm3.758.848a6.853 6.853 0 0 1-3.284-.838l-.493 1.073a7.884 7.884 0 0 0 3.777.965v-1.2Z"
        fill="#F9A33D"
      />
      <path
        d="M7.945 15.261c3.126 0 5.66-2.755 5.66-6.154 0-3.4-2.534-6.155-5.66-6.155-3.125 0-5.66 2.755-5.66 6.155 0 3.399 2.535 6.155 5.66 6.155Z"
        fill="#F2C94C"
        stroke="#F9A33D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.061 10.686c-.03.665-.552 1.177-1.164 1.144-.611-.034-1.082-.6-1.051-1.266l-.551-.03c-.047.996.659 1.845 1.575 1.895.916.05 1.696-.716 1.742-1.713a1.83 1.83 0 0 0-.267-1.026c-.186-.311-.482-.618-.934-.887l.012-.061a3.003 3.003 0 0 1-.237-.064 4.5 4.5 0 0 0-.13-.064l-.008.017c-.918-.34-1.209-1.026-1.247-1.29-.094-.658.32-1.275.925-1.378.605-.102 1.172.348 1.267 1.006l.545-.092c-.142-.986-.99-1.66-1.897-1.506-.906.153-1.526 1.077-1.385 2.063.073.509.54 1.415 1.732 1.806.485.255.75.535.895.777.158.266.186.508.178.67Z"
        fill="#F9A33D"
      />
      <path
        d="M7.946 4.803H7.55v.861h.396v-.86ZM8.341 12.119h-.396v.86h.396v-.86Z"
        fill="#F9A33D"
      />
    </g>
  </svg>
)

export default TokoramePointSvg
